module.exports = __webpack_public_path__ + "img/avatar1.8d1d8ec3.png";